/**
 * This file is largely copied from createCloudFileFromAttachmentData.ts in owa-attachment-suggestions.
 * We are copying these files because this feature is still in a volatile state, so we wish to avoid
 * attempting to refactor the code so that it can be used here.
 * There is also ongoing experimentation with the Attachment Suggestions feature.
 */
import { AttachmentFileType, CloudFile } from 'owa-attachment-file-types';
import { ReplyWithAttachmentSuggestion } from 'owa-attachment-suggestions';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { trace } from 'owa-trace';
import {
    FileProviderViewState,
    ProviderLoadStateOption,
    getProviderLoadState,
    lazyLoadProviders,
    getFileProviders,
} from 'owa-fileprovider-store';

export default async function createCloudFileFromAttachmentData(
    attachmentData: ReplyWithAttachmentSuggestion,
    onCloudFileReady: (cloudFile: CloudFile) => void
): Promise<void> {
    let cloudFile: CloudFile = null;

    if (getProviderLoadState() === ProviderLoadStateOption.NotLoaded) {
        const loadProviders = await lazyLoadProviders.import();

        loadProviders((providers: FileProviderViewState[]) => {
            cloudFile = finalizeAttachmentDataBeforeUpload(getFileProviders(), attachmentData);
            onCloudFileReady(cloudFile);
        });
    } else {
        cloudFile = finalizeAttachmentDataBeforeUpload(getFileProviders(), attachmentData);
        onCloudFileReady(cloudFile);
    }
}

function finalizeAttachmentDataBeforeUpload(
    providers: FileProviderViewState[],
    attachmentData: ReplyWithAttachmentSuggestion
): CloudFile {
    const providerId = extractOneDriveProFileProviderId(providers);

    return {
        fileType: AttachmentFileType.CloudSuggestion,
        name: attachmentData.FileName,
        size: null,
        providerId: providerId,
        providerType: AttachmentDataProviderType.OneDrivePro,
        location: attachmentData.Url,
        providerEndpointUrl: null,
        isFolder: false,
        fileId: attachmentData.Id,
        fileParentId: null,
        thumbnailUrl: null,
        previewUrl: null,
        type: null,
    };
}

function extractOneDriveProFileProviderId(providers: FileProviderViewState[]): string {
    for (let i = 0; i < providers.length; i++) {
        if (providers[i].type === AttachmentDataProviderType.OneDrivePro) {
            return providers[i].model.Id;
        }
    }

    trace.warn(
        'createCloudFileFromAttachmentData: Could not get OneDrive Pro provider ID. Attachment will not upload.'
    );
    return '';
}
